import { useTranslation } from "react-i18next";
import { EmailFlowLogDetails } from "@dashboard-v3/api";
import { Box, Grid, Typography } from "@material-ui/core";
import Title from "./Title";
import { isBlank } from "utils/string";

// See engine: core/src/main/java/com/mxhero/engine/core/services/DeliveryEventPublisher.java
type SmtpServerStatus = {
  status: string;
  statusDetail?: string;
  relay?: string;
  delay?: string;
  delays?: string;
  dsn?: string;
};

interface Props {
  event: EmailFlowLogDetails;
}

export default function MailSmtpDelivered({ event }: Props) {
  const { t } = useTranslation("tracing");
  const at = new Date(event.createdAt).toLocaleString();
  const smtpStatus = event.data?.smtpServerStatus as
    | SmtpServerStatus
    | undefined;

  const parsedDelay = parseFloat(smtpStatus?.delay);
  const relay = isBlank(smtpStatus?.relay) ? "-" : smtpStatus.relay;
  const statusBase = isBlank(smtpStatus?.status) ? "-" : smtpStatus.status;

  const status = !isBlank(smtpStatus?.statusDetail)
    ? `${statusBase} (${smtpStatus.statusDetail})`
    : statusBase;

  const delay =
    isBlank(smtpStatus?.delay) || isNaN(parsedDelay)
      ? "-"
      : t("delivered.delaySeconds", { count: parsedDelay });

  return (
    <>
      <Title timestamp={event.createdAt}>
        <Typography style={{ fontWeight: "500" }}>
          {t(`smtpDeliveryStatus.${smtpStatus?.status}`)}
        </Typography>
      </Title>
      <Box ml={2}>
        <Grid container direction="row" justifyContent="flex-start" spacing={3}>
          <Grid item>
            <Property title={t("delivered.at")} value={at} />
          </Grid>
          <Grid item>
            <Property title={t("delivered.delay")} value={delay} />
          </Grid>
          <Grid item>
            <Property title={t("delivered.relay")} value={relay} />
          </Grid>
          <Grid item xs={12}>
            <Property title={t("delivered.status")} value={status} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

function Property({ value, title }: { value: string; title: string }) {
  return (
    <Box display="flex" flexDirection="column">
      <Typography color="textSecondary" component="span" variant="caption">
        {title}
      </Typography>
      <Box>{value}</Box>
    </Box>
  );
}
